import ProfileRouter from './profile.router'

export default {
  path: '/sms',
  component: () => import('../views/theme/Base'),
  children: [
    {
      path: '/',
      name: 'sms',
      component: () => import('../views/pages/sms/Dashboard.vue'),
      meta: {
        breadcrumbs: [{ title: 'الرئيسية' }],
      },
    },
    ProfileRouter,
    {
      path: 'terms',
      name: 'terms',
      component: () => import('../views/pages/sms/terms/Terms.vue'),
      meta: {
        breadcrumbs: [{ title: 'الفصول الدراسية' }],
        level: 'university',
        roles: 'general registrar|study and exams',
      },
    },
    {
      path: 'terms/:term_id/stages',
      name: 'term-stages',
      component: () => import('../views/pages/sms/terms/TermStages.vue'),
      meta: {
        breadcrumbs: [{ title: 'الفصول الدراسية', route: { name: 'terms' } }, { title: 'الجدول الزمني للفصل الدراسي' }],
        level: 'university',
        roles: 'study and exams',
      },
    },
    {
      path: 'terms/:term_id/settings',
      name: 'term-settings',
      component: () => import('../views/pages/sms/terms/TermSettings.vue'),
      meta: {
        breadcrumbs: [{ title: 'الفصول الدراسية', route: { name: 'terms' } }, { title: 'إعدادات الفصل الدراسي' }],
        level: 'university',
        roles: 'study and exams',
      },
    },

    {
      path: 'terms/:term_id/subjects',
      name: 'term-subjects',
      component: () => import('../views/pages/sms/terms/TermSubjects.vue'),
      meta: {
        breadcrumbs: [{ title: 'الفصول الدراسية', route: { name: 'terms' } }, { title: 'تسجيلات المواد الدراسية' }],
        level: 'university|school|department',
        roles: 'general registrar|study and exams|department head',
      },
    },
    {
      path: 'terms/:term_id/subjects/:subject_id/students',
      name: 'term-subject-students',
      component: () => import('../views/pages/sms/terms/TermSubjectStudents.vue'),
      meta: {
        breadcrumbs: [
          { title: 'الفصول الدراسية', route: { name: 'terms' } },
          { title: 'تسجيلات المواد الدراسية', route: { name: 'term-subjects' } },
          { title: 'تسجيلات الطلبة' },
        ],
        level: 'university|school|department',
        roles: 'general registrar|study and exams|department head',
      },
    },
    {
      path: 'timetables',
      name: 'timetables',
      component: () => import('../views/pages/sms/timetables/Timetables.vue'),
      meta: {
        breadcrumbs: [{ title: 'الفصول الدراسية' }],
        level: 'school|department',
        roles: 'study and exams|department head',
      },
    },
    {
      path: 'timetables/:timetable_id',
      name: 'timetable',
      component: () => import('../views/pages/sms/timetables/Schedule.vue'),
      meta: {
        breadcrumbs: [{ title: 'الفصول الدراسية', route: { name: 'timetables' } }, { title: 'الجدول الدراسي' }],
        level: 'school|department',
        roles: 'study and exams|department head',
      },
    },
    {
      path: 'student-applications',
      name: 'studentApplications',
      component: () => import('../views/pages/sms/students/StudentApplications'),
      meta: {
        breadcrumbs: [{ title: 'طلبات التحاق الطلبة' }],
        level: 'university',
        roles: 'general registrar|general registrar data entry',
      },
    },
    {
      path: 'student-applications/create',
      name: 'createStudentApplication',
      component: () => import('../views/pages/sms/students/StudentApplicationForm'),
      meta: {
        breadcrumbs: [
          { title: 'طلبات التحاق الطلبة', route: { name: 'studentApplications' } },
          { title: 'إضافة طالب' },
        ],
        level: 'university',
        roles: 'general registrar|general registrar data entry',
      },
    },
    {
      path: 'student-applications/:student_id',
      name: 'editStudentApplication',
      component: () => import('../views/pages/sms/students/StudentApplicationForm'),
      meta: {
        breadcrumbs: [
          { title: 'طلبات التحاق الطلبة', route: { name: 'studentApplications' } },
          { title: 'تعديل طالب' },
        ],
        level: 'university',
        roles: 'general registrar|general registrar data entry',
      },
    },
    {
      path: 'students',
      name: 'students',
      component: () => import('../views/pages/sms/students/Students'),
      meta: {
        breadcrumbs: [{ title: 'إدارة الطلبة' }],
        level: 'university|school|department',
        roles:
          'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
      },
    },
    {
      path: 'graduations',
      name: 'graduations',
      component: () => import('../views/pages/sms/students/Graduations'),
      meta: {
        breadcrumbs: [{ title: 'إدارة الخريجين' }],
        level: 'university|school|department',
        roles:
          'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor',
      },
    },
    {
      path: 'graduation-requests',
      name: 'graduation-requests',
      component: () => import('../views/pages/sms/students/GraduationRequests'),
      meta: {
        breadcrumbs: [{ title: 'إدارة الطلبة', route: { name: 'students' } }, { title: 'طلبات التخرج' }],
        level: 'university|school|department',
        roles: 'general registrar|general registrar data entry|study and exams|department head|school registrar',
      },
    },
    {
      path: 'students/new',
      name: 'newStudent',
      component: () => import('../views/pages/sms/students/StudentForm'),
      meta: {
        breadcrumbs: [{ title: 'إدارة الطلبة', route: { name: 'students' } }, { title: 'إضافة طالب' }],
        level: 'university',
        roles: 'general registrar|general registrar data entry',
      },
    },
    {
      path: 'students/:student_id',
      component: () => import('../views/pages/sms/students/profile/StudentProfile.vue'),
      meta: {
        breadcrumbs: [{ title: 'إدارة الطلبة', route: { name: 'students' } }, { title: 'صفحة الطالب' }],
        level: 'university|school|department',
        roles:
          'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
      },
      children: [
        {
          path: '/',
          name: 'view-student',
          component: () => import('../views/pages/sms/students/profile/StudentPersonalInfo.vue'),
          meta: {
            breadcrumbs: [{ title: 'إدارة الطلبة', route: { name: 'students' } }, { title: 'صفحة الطالب' }],
            level: 'university|school|department',
            roles:
              'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
          },
        },
        {
          path: 'academic-record',
          name: 'student-academic-record',
          component: () => import('../views/pages/sms/students/profile/StudentAcademicRecord.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'السجل الدراسي' },
            ],
            level: 'university|school|department',
            roles:
              'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
          },
        },
        {
          path: 'terms',
          name: 'student-terms',
          component: () => import('../views/pages/sms/students/profile/StudentTerms.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'الفصول الدراسية للطالب' },
            ],
            level: 'university|school|department',
            roles:
              'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
          },
        },
        {
          path: 'terms/:term_id/subjects',
          name: 'student-subjects',
          component: () => import('../views/pages/sms/students/profile/StudentSubjects.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'الفصول الدراسية', route: { name: 'student-terms' } },
              { title: 'المواد الدراسية للطالب' },
            ],
            level: 'university|school|department',
            roles:
              'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
          },
        },
        {
          path: 'notices',
          name: 'student-notices',
          component: () => import('../views/pages/sms/students/profile/StudentNotices.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'الإنذارات' },
            ],
            level: 'university|school|department',
            roles:
              'general registrar|general registrar data entry|study and exams|department head|school registrar|monitor|accountant',
          },
        },
        {
          path: 'internal-transfer',
          name: 'student-internal-transfer',
          component: () => import('../views/pages/sms/students/profile/StudentInternalTransfer.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'السجل الدراسي', route: { name: 'student-academic-record' } },
              { title: 'معادلة داخلية' },
            ],
            level: 'university',
            roles: 'general registrar',
          },
        },
        {
          path: 'outer-transfer',
          name: 'student-outer-transfer',
          component: () => import('../views/pages/sms/students/profile/StudentOuterTransfer.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'السجل الدراسي', route: { name: 'student-academic-record' } },
              { title: 'معادلة خارجية' },
            ],
            level: 'university',
            roles: 'general registrar',
          },
        },
        {
          path: 'theses',
          name: 'student-theses',
          component: () => import('../views/pages/sms/students/profile/StudentTheses.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'الرسائل العلمية' },
            ],
            level: 'university|school|department',
          },
        },
        {
          path: 'theses/create',
          name: 'create-student-thesis',
          component: () => import('../views/pages/sms/students/profile/StudentThesisForm.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'الرسائل العلمية', route: { name: 'student-theses' } },
              { title: 'إضافة مقترح رسالة علمية' },
            ],
            level: 'university|school',
            roles: 'general registrar|school registrar|general registrar data entry',
          },
        },
        {
          path: 'theses/:thesis_id',
          name: 'edit-student-thesis',
          component: () => import('../views/pages/sms/students/profile/StudentThesisForm.vue'),
          meta: {
            breadcrumbs: [
              { title: 'إدارة الطلبة', route: { name: 'students' } },
              { title: 'صفحة الطالب', route: { name: 'view-student' } },
              { title: 'الرسائل العلمية', route: { name: 'student-theses' } },
              { title: 'تحرير الرسالة العلمية' },
            ],
            level: 'university|school',
            roles: 'general registrar|school registrar|general registrar data entry',
          },
        },
      ],
    },
    {
      path: 'students/:student_id/edit',
      name: 'editStudent',
      component: () => import('../views/pages/sms/students/StudentForm'),
      meta: {
        breadcrumbs: [{ title: 'إدارة الطلبة', route: { name: 'students' } }, { title: 'تعديل طالب' }],
        level: 'university|school|department',
        roles: 'general registrar|general registrar data entry|study and exams|department head|school registrar',
      },
    },
    {
      path: 'reports',
      name: 'sms-reports',
      component: () => import('../views/pages/sms/reports/Reports.vue'),
      meta: {
        breadcrumbs: [{ title: 'إدارة التقارير' }],
        level: 'university|school|department',
        roles: 'general registrar|study and exams|department head|monitor',
      },
    },
    // Student Routes
    {
      path: 'timetable',
      name: 'student-timetable',
      component: () => import('../views/pages/sms/student/Timetable.vue'),
      meta: {
        breadcrumbs: [{ title: 'الجدول الدراسي للقسم' }],
        level: 'department',
        roles: 'student',
      },
    },
    {
      path: 'academic-record',
      name: 'academic-record',
      component: () => import('../views/pages/sms/student/AcademicRecord.vue'),
      meta: {
        breadcrumbs: [{ title: 'السجل الدراسي' }],
        level: 'department',
        roles: 'student',
      },
    },
    {
      path: 'academic-record/:term_id/subjects',
      name: 'academic-record-subjects',
      component: () => import('../views/pages/sms/student/AcademicRecordSubjects.vue'),
      meta: {
        breadcrumbs: [{ title: 'السجل الدراسي', route: { name: 'academic-record' } }, { title: 'المواد الدراسية' }],
        level: 'department',
        roles: 'student',
      },
    },
    {
      path: 'academic-record/:term_id/enrollment',
      name: 'enrollment',
      component: () => import('../views/pages/sms/student/Enrollment.vue'),
      meta: {
        breadcrumbs: [{ title: 'السجل الدراسي', route: { name: 'academic-record' } }, { title: 'تنزيل المواد' }],
        level: 'department',
        roles: 'student',
      },
    },
    {
      path: '404',
      name: 'sms-404',
      component: () => import('../views/pages/error/Error.vue'),
      meta: { backTo: '/sms' },
    },
    {
      path: '*',
      redirect: '/sms/404',
    },
  ],
}
